import GlobalLoading from "./globalLoading/index"
import PartLoading from "./partLoading/index"

export {
    GlobalLoading,
    PartLoading
}